import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

// Layouts
import Layout1 from '@/layout/Layout1'
import { Yetki } from '@/utils/enums'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/giris',
      name: 'OturumAc',
      component: () => import('@/views/auth/login')
    },
    {
      path: '/cgi-sys/defaultwebpage.cgi',
      redirect: '/'
    },
    {
      path: '/uzaktan-giris/:guid?',
      name: 'UzaktanOturumAc',
      component: () => import('@/views/auth/uzaktan-giris')
    },
    {
      path: '/kayit',
      name: 'Kayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/bayan-kayit',
      name: 'Bayan-Kayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/bayankayit',
      name: 'BayanKayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/hocakayit',
      name: 'HocaKayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/hoca-kayit',
      name: 'Hoca-Kayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/bayanhocakayit',
      name: 'BayanHocaKayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/bayan-hoca-kayit',
      name: 'Bayan-Hoca-Kayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/',
      component: Layout1,
      children: [{
        path: '',
        component: () => import('@/views/home'),
        name: 'AnaSayfa'
      }, {
        path: 'kisi/liste',
        name: 'KisiListesi',
        meta: [{
          Roles: [Yetki.SUPERADMİN, Yetki.ADMIN, Yetki.ULKE, Yetki.BOLGE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/kisiV2')
      }, {
        path: 'vakit',
        name: 'VakitGuncelle',
        meta: [{
          Roles: [Yetki.SUPERADMİN, Yetki.ADMIN, Yetki.ULKE, Yetki.BOLGE, Yetki.IL, Yetki.ILCE, Yetki.HOCA, Yetki.YETKIYOK]
        }],
        component: () => import('@/views/vakit')
      }]
    }, {
      path: '*',
      component: NotFound
    }]
})

export default router
